import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const StateCodeSchema = z.string()
export type StateCode = z.infer<typeof StateCodeSchema>

export const PopoutUrlBehaviorSchema = z.object(
  { type: z.literal('popout_url'), url: z.string() },
  { message: 'Popout url behavior must be a valid object' },
)
export type PopoutUrlBehavior = z.infer<typeof PopoutUrlBehaviorSchema>

export const InternalFlowBehaviorSchema = z.object(
  { type: z.literal('internal_flow'), partner: z.string(), disclosure: z.string().optional() },
  { message: 'Internal flow behavior must be a valid object' },
)
export type InternalFlowBehavior = z.infer<typeof InternalFlowBehaviorSchema>

export const HideBehaviorSchema = z.object(
  { type: z.literal('hide') },
  { message: 'Hide behavior must be a valid object' },
)
export type HideBehavior = z.infer<typeof HideBehaviorSchema>

export const StateBehaviorSchema = z.discriminatedUnion('type', [
  PopoutUrlBehaviorSchema,
  InternalFlowBehaviorSchema,
  HideBehaviorSchema,
])

export type StateBehavior = z.infer<typeof StateBehaviorSchema>

export const StateMappingSchema = z.record(StateCodeSchema, StateBehaviorSchema)
export type StateMapping = z.infer<typeof StateMappingSchema>

export const MortgageModuleWebviewFlowSchema = z.object(
  { state_mapping: StateMappingSchema },
  { message: 'Mortgage module webview flow must be a valid object' },
)

export type MortgageModuleWebviewFlow = z.infer<typeof MortgageModuleWebviewFlowSchema>

export function useMortgageModuleWebviewFlowParameterStore() {
  return useMesaParameterStore('mortgage_module_-_webview_flow')
}
